<template>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card min-height="80%" min-width="80%">
      <v-toolbar elevation="2" color="primary" dark dense>
        <v-spacer/>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid class="ma-0 pa-2">
          <v-row no-gutters>
            <span>現在表示しているデータをテンプレートとして登録します。</span>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12" class="px-1">
              <dd-text-box
                label="テンプレート名称"
                v-model="rec.xlsTemplateNm"
                ref="xlsTemplateNm"
                :length="50"
                :valueType="Ctrls.InputTypes.Free"
                :required="true"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="営業所コード/名称"
                v-model="rec.eigyoshoCd"
                ref="eigyoshoCd"
                :length="100"
                :required="false"
                :readonly="eigyoshoReadOnly"
                :valueType="Ctrls.InputTypes.Free"
                item-value="eigyoshoCd"
                item-text="eigyoshoNm"
                titleText="営業所マスタ検索"
                :headerList="headersEigyoshoList"
                :itemList="filteredEigyoshoList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="人員コード/名称"
                v-model="rec.jininCd"
                ref="jininCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="jininCd"
                item-text="jininNm"
                titleText="人員マスタ検索"
                :headerList="headersJininList"
                :itemList="filteredJininList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="車両番号/自動車表示名"
                v-model="rec.sharyoCd"
                ref="sharyoCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="sharyoNo"
                item-text="jidoshaHyojiNm"
                titleText="車両マスタ検索"
                :headerList="headersSharyoList"
                :itemList="filteredSharyoList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="取引先コード/名称"
                v-model="rec.torihikisakiCd"
                ref="torihikisakiCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="torihikisakiCd"
                item-text="torihikisakiNm"
                titleText="取引先マスタ検索"
                :headerList="headersTorihikisakiList"
                :itemList="filteredTorihikisakiList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="品名コード/名称"
                v-model="rec.hinmeiCd"
                ref="hinmeiCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="hinmeiCd"
                item-text="hinmeiNm"
                titleText="品名マスタ検索"
                :headerList="headersHinmeiList"
                :itemList="filteredHinmeiList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="発地コード/名称"
                v-model="rec.hatsuchiCd"
                ref="hatsuchiCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="hacchakuchiCd"
                item-text="hacchakuchiNm"
                titleText="発着地マスタ検索"
                :headerList="headersHacchakuchiList"
                :itemList="filteredHatsuchiList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
              <dd-code-text-box-child
                label="着地コード/名称"
                v-model="rec.chakuchiCd"
                ref="chakuchiCd"
                :length="100"
                :required="false"
                :readonly="false"
                :valueType="Ctrls.InputTypes.Free"
                item-value="hacchakuchiCd"
                item-text="hacchakuchiNm"
                titleText="発着地マスタ検索"
                :headerList="headersHacchakuchiList"
                :itemList="filteredChakuchiList"
                :abbreviatedDisplay="abbreviatedDisplayChild"
                :itemsPerPage.sync="innerItemsPerPageChild"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3">
          <dd-footer-button
            @click="onCloseClick">
            閉じる
          </dd-footer-button>
          <v-spacer></v-spacer>
          <dd-custom-button
            tooltipText="入力した内容で保存します。"
            :tooltipTop="true"
            :enableToolTip="true"
            :rounded="false"
            color="#e65100"
            dark
            @click="onSaveButtonClick"
          >
            テンプレートを登録する
          </dd-custom-button>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCodeTextBoxChild from '@/components/DdCodeTextBoxChild'
import DdCustomButton from '@/components/DdCustomButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdTextBox from '@/components/DdTextBox'

import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import { mapGetters } from 'vuex'
/**
 * @file スプレッドシート用テンプレート登録用ダイアログ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [showDialog=false] - ダイアログ表示可否
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @vue-prop {String} headerType - mstXlsImportMappingの対象formatCd
 * @vue-prop {String} spreadsheetData - スプレッドシートのデータ（変換処理で使用）
 * @vue-prop {String} spreadsheetColumns - スプレッドシートのヘッダー（変換処理で使用）
 * @vue-prop {String} eigyoshoReadOnly - 営業所ロックフラグ
 * @example
    <dd-xls-template-edit-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerType="headerType"
      :spreadsheetData="spreadsheetData"
      :spreadsheetColumns="spreadsheetColumns"
      :eigyoshoReadOnly="eigyoshoReadOnly"
      [atmark]close="onDialogClosed"/>
 */
export default {
  mixins: [flowMixin],
  name: 'DdXlsTemplateEditDialog',
  components: {
    DdCodeTextBoxChild,
    DdCustomButton,
    DdFooterButton,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * ダイアログタイトル
     */
    titleText: {
      type: String,
      default: 'テンプレート登録'
    },
    /**
     * mstXlsImportMappingの対象formatCd
     */
    headerType: {
      type: String,
      default: ''
    },
    /**
     * スプレッドシートのデータ（変換処理で使用）
     */
    spreadsheetData: {
      type: Array,
      default: () => []
    },
    /**
     * スプレッドシートのヘッダー（変換処理で使用）※登録対象にしたくない項目があるなら事前に省いておく
     */
    spreadsheetColumns: {
      type: Array,
      default: () => []
    },
    /**
     * 変換処理の動作引数（スプレッドシートのデータからmstXlsTemplateDetailに変換）
     */
    buildDetailOption: {
      type: Object,
      default: () => ({})
    },
    /**
     * スプレッドシートの行一意キー
     */
    spreadsheetKey: {
      type: String,
      default: 'rowNo'
    },
    /**
     * スプレッドシートから更新対象を特定するための項目名称（boolean）
     */
    spreadsheetEditFlg: {
      type: String,
      default: 'editFlg'
    },
    /**
     * 営業所ロックフラグ
     */
    eigyoshoReadOnly: {
      type: Boolean,
      default: false
    },
    /*
     * 省略表示モード
     */
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    /*
     * 省略表示モード（コードテキストボックスで更に表示されるダイアログに対して）
     */
    abbreviatedDisplayChild: {
      type: Boolean,
      default: false
    },
    /*
     * 1ページ当たりの行数（コードテキストボックスで更に表示されるダイアログに対して）
     */
    itemsPerPageChild: {
      type: Number,
      default: 25
    }
  },
  data: () => ({
    title: '',
    rec: {
      id: -1,
      xlsTemplateNm: null,
      sharyoCd: null,
      jininCd: null,
      eigyoshoCd: null,
      torihikisakiCd: null,
      hinmeiCd: null,
      hatsuchiCd: null,
      chakuchiCd: null
    },
    headersSharyoList: header.mstSharyoHeaders,
    headersJininList: header.mstJininHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,

    innerItemsPerPageChild: null
  }),
  created () {
  },
  mounted () {
    this.title = this.titleText
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    // 使用元の画面でloadMastersを済ませてください
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      userEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (this.eigyoshoLockFlg || elem.eigyoshoCd === this.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.sharyoCd > elem2.sharyoCd) { return 1 }
        if (elem1.sharyoCd === elem2.sharyoCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (this.eigyoshoLockFlg || elem.eigyoshoCd === this.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    filteredHatsuchiList () {
      return this.filteredHacchakuchiList.filter(elem => elem.hatsuchiFlg)
    },
    filteredChakuchiList () {
      return this.filteredHacchakuchiList.filter(elem => elem.chakuchiFlg)
    }
  },
  methods: {
    onCloseClick: function (e) {
      this.$emit('close')
    },
    onSaveButtonClick: function () {
      const isValid = this.validateAll(this.$refs)
      if (!isValid) { return }

      const mstXlsTemplateKihon = { ...this.rec, formatCd: this.headerType }
      mstXlsTemplateKihon.mstXlsTemplateDetailList = this.buildDetail(this.buildDetailOption) || []
      console.log('register data', mstXlsTemplateKihon)
      this.Effects.loadStart()
      return new Promise(resolve => {
        this.HttpClient.post('/api/v1/MstXlsTemplateKihon/CreateWithChildren', mstXlsTemplateKihon)
          .then((data) => {
            this._setMessages(data).then(() => {
              if (!data.isValid) {
                this.Effects.loadComplete()
                return
              }

              // indexedDBを最新化
              this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlstemplatekihon'] }).then(() => {
                this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlstemplatekihon'], version: 1, kinoId: 0 }).then(() => {
                  this.$emit('close')
                  this.Effects.loadComplete()
                  resolve()
                })
              })
            })
          })
      })
    },
    /**
     * mstXlsTemplateDetailへの変換処理
     * @public
     * @param {Object} option 動作引数
     * @param {Boolean} option.isKeepEmptyRows 登録対象データに空行を含めるかどうか
     * @param {Function} option.getRegisterTargetList 登録対象データ取得処理
     * @param {Function} option.rowToDetail 行データからmstXlsTemplateDetail形式への変換処理
     */
    buildDetail: function (option) {
      const opt = {
        isKeepEmptyRows: option.isKeepEmptyRows || false,
        getRegisterTargetList: option.getRegisterTargetList || this.getRegisterTargetList,
        rowToDetail: option.rowToDetail || this.rowToDetail
      }
      const columns = this.spreadsheetColumns
      const rows = this.spreadsheetData
      const target = opt.getRegisterTargetList(columns, rows, opt.isKeepEmptyRows)
      const details = opt.rowToDetail(columns, rows, target)
      return details
    },
    isNullOrEmpry: function (tex) {
      var trimed = String(tex ?? '').trim()
      return trimed === '' || trimed === null || trimed === undefined
    },
    setMstXlsTemplateDetail: function (rowNo, bindItemNm, value) {
      return {
        id: -1,
        tekiyoStartYmd: '2000/01/01',
        tekiyoEndYmd: '2099/12/31',
        mstXlsTemplateKihonId: 0,
        rowNo: rowNo,
        bindItemNm: bindItemNm,
        value: value,
        hyojiOrder: 9999
      }
    },
    getRegisterTargetList: function (columns, rows, isKeepEmptyRows) {
      // 登録対象を取得
      var maxInputRowNo = Math.max(...rows.filter(elem => elem[this.spreadsheetEditFlg] === true).map(elem => elem[this.spreadsheetKey]), 0)
      var target = rows.filter(elem => {
        return elem.rowNo <= maxInputRowNo
      }).map(elem => {
        // 値が入力されている項目一覧を取得
        elem.validItems = columns.filter(col => !this.isNullOrEmpry(elem[col.name]))
        return elem
      }).sort((a, b) => {
        return a[this.spreadsheetKey] - b[this.spreadsheetKey]
      })
      if (isKeepEmptyRows === false) {
        // 空行を省略する
        target = target.filter(elem => elem.validItems.length > 0)
      }

      return target
    },
    rowToDetail: function (columns, rows, target) {
      var result = target.reduce((res, cur, index) => {
        // 値が入力されている項目一覧
        var valuesList = cur.validItems
        // detailの形にする
        var detailList = valuesList.reduce((_res, _cur) => {
          _res.push(this.setMstXlsTemplateDetail(index + 1, _cur.name, cur[_cur.name]))
          return _res
        }, [])
        res = res.concat(detailList)
        return res
      }, [])
      return result
    },
    setMstXlsTemplateKihon: function () {
      return {
        id: -1,
        tekiyoStartYmd: '2000/01/01',
        tekiyoEndYmd: '2099/12/31',
        xlsTemplateNm: null,
        sharyoCd: null,
        jininCd: null,
        eigyoshoCd: this.userEigyoshoCd,
        torihikisakiCd: null,
        hinmeiCd: null,
        hatsuchiCd: null,
        chakuchiCd: null,
        hyojiOrder: 9999,
        hyojiFlg: true
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      const initRec = this.setMstXlsTemplateKihon()
      this.rec = Object.assign({}, initRec)
      this.innerItemsPerPageChild = this.itemsPerPageChild
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 600 !important;
}
</style>
